// The days a lease ran of a cost's period as the cost drawer's split table
// shows them (Lewis, 2026-10-19): the ratio on one line, the full sentence
// in its hover.

import { Tooltip } from "@rentiohq/web-shared/dist/components";
import React from "react";
import {
  IOccupiedDays,
  occupiedDaysRatio,
  occupiedDaysSentence,
} from "../occupiedDays.utils";

export const OccupiedDays: React.FC<{ occupied: IOccupiedDays }> = ({
  occupied,
}) => (
  <Tooltip tooltipContent={occupiedDaysSentence(occupied)}>
    <span style={{ cursor: "help", whiteSpace: "nowrap" }}>
      {occupiedDaysRatio(occupied)}
    </span>
  </Tooltip>
);
